package com.nonopn.skywatcher.common.app.portfolio.main

import androidx.compose.material.ScaffoldState
import com.nonopn.skywatcher.app.utils.safeLaunch
import com.nonopn.skywatcher.common.app.api.impl.ApiInterface
import com.nonopn.skywatcher.common.app.api.impl.ApiInterfaceFake
import com.nonopn.skywatcher.common.app.navigation.RouteNoThunderDetectionSelected
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.appbar.AppBarStateProvider
import com.nonopn.skywatcher.design.appbar.FloatingActionButtonState
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigationListener
import eu.codlab.navigation.NavigatorModel
import eu.codlab.viewmodel.StateViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import kotlinx.serialization.Serializable

@Suppress("TooManyFunctions")
class NoThunderDetectionSelectedModel(
    val isSystemDarkMode: Boolean,
    private val currentApi: ApiInterface,
) : StateViewModel<NoThunderDetectionSelectedModelState>(
    NoThunderDetectionSelectedModelState(
        RouteNoThunderDetectionSelected,
        isSystemDarkMode = isSystemDarkMode,
        currentApi = currentApi,
    )
), AppBarStateProvider, NavigationListener {
    var mainCompositionScope: CoroutineScope? = null
    var navigator: NavigatorModel? = null
    var scaffoldState: ScaffoldState? = null

    companion object {
        fun fake() = NoThunderDetectionSelectedModel(
            false,
            ApiInterfaceFake
        )
    }

    override fun setAppBarState(appBarState: AppBarState) {
        safeLaunch {
            updateState {
                copy(appBarState = appBarState)
            }
        }
    }

    fun setFloatingActionButton(floatingActionButtonState: FloatingActionButtonState?) =
        safeLaunch {
            updateState {
                copy(floatingActionButtonState = floatingActionButtonState)
            }
        }

    fun popBackStack() {
        navigator?.navigateUp()
    }

    fun floatingActionButton(): FloatingActionButtonState? {
        return states.value.floatingActionButtonState
    }

    fun show(navigateTo: NavigateTo) {
        if (navigateTo.stack.popBackStack) {
            popBackStack()
        }

        navigator?.navigateTo(navigateTo)

        mainCompositionScope?.launch {
            try {
                scaffoldState?.drawerState?.close()
            } catch (err: Throwable) {
                err.printStackTrace()
            }
        }

        updateState {
            copy(
                currentRoute = navigateTo.route,
                appBarState = AppBarState.Regular(),
                floatingActionButtonState = null
            )
        }
    }

    override fun shown(navigateTo: NavigateTo) {
        // nothing to do but should override above ?
    }
}

@Serializable
data class SpecificData(
    val nothing: Boolean = false
)